import { Calendar } from "lucide-react";

interface ReportHeaderProps {
  vendorName: string;
  category: string;
  evaluationDate: string;
  reportVersion: string;
}

export function ReportHeader({ vendorName, category, evaluationDate, reportVersion }: ReportHeaderProps) {
  return (
    <div className="relative overflow-hidden bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 sm:py-10">
        {/* Top row: Logo + Title */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 mb-2">
          {/* Logo */}
          <img 
            src="/logo-no-text.png" 
            alt="FeedForward AI" 
            className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
          />
          
          {/* Title Section */}
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-light tracking-tight text-white">
              {vendorName}
            </h1>
            <p className="text-[#d4975c] uppercase tracking-[0.25em] text-xs sm:text-sm font-medium mt-1">
              AI Vendor Evaluation Report
            </p>
          </div>

          {/* Version & Date */}
          <div className="text-left sm:text-right text-sm">
            <div className="text-slate-300 mb-1">Version {reportVersion}</div>
            <div className="flex items-center gap-2 sm:justify-end text-slate-400">
              <Calendar className="w-4 h-4" />
              {evaluationDate}
            </div>
          </div>
        </div>
        
        {/* Category subtitle */}
        <div className="sm:ml-[72px] lg:ml-[88px]">
          <p className="text-slate-300 text-sm sm:text-base">{category}</p>
        </div>
      </div>
    </div>
  );
}
